import { render } from "./KodingMengikutDaerah.vue?vue&type=template&id=b3d87772"
import script from "./KodingMengikutDaerah.vue?vue&type=script&lang=js"
export * from "./KodingMengikutDaerah.vue?vue&type=script&lang=js"

import "./KodingMengikutDaerah.vue?vue&type=style&index=0&id=b3d87772&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__